module.exports = __webpack_public_path__ + "static/media/0223_IMG_LES_MURS_PALOMINO_W_VPL2100_VERTICALE.d318e0bc.png";